import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type RHFMultiSelectProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    placeholder?: string;
    inputProps?: MultiSelectProps;
};

export const RHFMultiSelect = ({ control, name, rules, placeholder, inputProps }: RHFMultiSelectProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
                <MultiSelect
                    id={field.name}
                    {...field}
                    placeholder={placeholder}
                    display='chip'
                    showClear={true}
                    {...inputProps}
                />
            )}
        />
    );
};
